import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { CodonUsageCalc } from "../components/CodonUsageCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.codon_tool_name()}
        toolPath="/codon-usage"
      />
      <SciHeader title={m.codon_h1()} intro={m.codon_intro()} />

      <CodonUsageCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.codon_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.codon_ex1(), m.codon_ex2(), m.codon_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.codon_faq_q1(), a: m.codon_faq_a1() },
          { q: m.codon_faq_q2(), a: m.codon_faq_a2() },
          { q: m.codon_faq_q3(), a: m.codon_faq_a3() },
          { q: m.codon_faq_q4(), a: m.codon_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
